import { render, staticRenderFns } from "./XLSXInput.vue?vue&type=template&id=f995c646&scoped=true&"
import script from "./XLSXInput.vue?vue&type=script&lang=js&"
export * from "./XLSXInput.vue?vue&type=script&lang=js&"
import style0 from "./XLSXInput.vue?vue&type=style&index=0&id=f995c646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f995c646",
  null
  
)

export default component.exports